import { TuiStatus } from '@taiga-ui/kit';
import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  model,
  OnInit,
  signal,
} from '@angular/core';
import { AccountService } from '@core/services/account/account.service';
import { WorkflowLogoutGuardService } from '@core/services/workflow/workflow-logout-guard.service';
import {
  tuiAvatarOptionsProvider,
  TuiBadge,
  TuiAvatar,
  TuiChevron,
  TuiAutoColorPipe,
  TuiInitialsPipe,
} from '@taiga-ui/kit';
import { environment } from '@environment/environment';
import { TuiDropdown, TuiButton } from '@taiga-ui/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DeviceDetectorService } from '@core/services';
import { ThemeSelectorComponent } from '@core/components';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OutkeepPermissionService } from '@core/services/permission';

@Component({
  selector: 'x-profile',
  imports: [
    TuiStatus,
    TuiAutoColorPipe,
    TuiInitialsPipe,
    AsyncPipe,
    TuiAvatar,
    TuiDropdown,
    TuiButton,
    TranslatePipe,
    ThemeSelectorComponent,
    RouterLink,
    TuiBadge,
    TuiChevron,
  ],
  templateUrl: './profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    tuiAvatarOptionsProvider({
      size: 'l',
      round: false,
    }),
  ],
})
export class ProfileComponent implements OnInit {
  private readonly accountService = inject(AccountService);
  private readonly workflowLogoutGuard = inject(WorkflowLogoutGuardService);
  readonly deviceService = inject(DeviceDetectorService);
  readonly router = inject(Router);
  readonly permissionService = inject(OutkeepPermissionService);
  readonly currentUser$ = this.accountService.currentUser$;
  private readonly destroyRef = inject(DestroyRef);
  public dropdownOpen = model(false);
  public isNotProfilePage = signal(false);
  public envConfig = signal<Record<string, any>>(this.getEnvironment());

  ngOnInit() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event: NavigationEnd) => {
        this.isNotProfilePage.set(event.urlAfterRedirects !== '/profile');
      });
  }

  getAvatarUrl(avatar?: string) {
    if (avatar) {
      return environment.staticUrl + avatar;
    }

    return '';
  }

  async logout() {
    if (this.dropdownOpen()) {
      this.closeDropdown();
    }

    await this.workflowLogoutGuard.logout();
  }

  closeDropdown() {
    this.dropdownOpen.set(false);
  }

  getEnvironment() {
    const result = {
      title: '',
      style: '',
    };

    switch (environment.xOutkeepInfrastructureEnv) {
      case 'local':
        result.title = 'Local';
        result.style = 'x-env-default';
        break;
      case 'development':
        result.title = 'Dev';
        result.style = 'positive';
        break;
      case 'stage':
        result.title = 'Stage';
        result.style = 'info';
        break;
      case 'production':
        result.title = 'PROD!';
        result.style = 'negative';
        break;
      default:
        result.title = 'Неопределенное окружение';
        result.style = 'warning';
        break;
    }

    return result;
  }
}
